import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

export interface TokenInterface {
    __v: number;
    _id: string;
    createdAt: Date;
    email: string;
    isSilent: boolean;
    maxUseCount: number;
    updatedAt: Date;
    usedCount: number;
    userId: string;
    validUntil: Date;
}

@Injectable({ providedIn: 'root' })
export class TokensService {
    private readonly httpClient = inject(HttpClient);

    protected backendApi: string = environment.url.backendApi;
    // @API tokens
    protected serviceName = 'tokens';

    public create(item: any): Promise<TokenInterface> {
        // @API tokens.post
        const url = `${environment.url.backendApi}/${this.serviceName}`;
        return this.httpClient.post<any>(url, item).toPromise();
    }
}
